import { Box } from '@mui/material'
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import routes from '../../routes/AuthRoutes/authRoutes'
import styles from './authStyle'

export default function Pages() {
  const wrapper: any = React.createRef()
  React.useEffect(() => {
    document.body.style.overflow = 'unset'
  })

  const getRoutes = (routes: any) => {
    return routes.map((prop: any, key: any) => {
      if (prop.collapse) {
        return getRoutes(prop.views)
      }
      if (prop.layout === '/auth') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        )
      } else {
        return null
      }
    })
  }

  return (
    <div>
      <Box component={'div'} sx={styles.wrapper} ref={wrapper}>
        <Switch>
          {getRoutes(routes)}
          <Redirect from="/auth" to="/auth/login" />
        </Switch>
      </Box>
    </div>
  )
}
